import {
  toAnswerIndexes,
  type Answers,
} from '@/modules/simulado/domain/entities/answer.entity';
import type { AnswerKeyEntry } from './answer-key.entity';
import {
  readTendencia,
  readableQuestions,
  toSubmittedAnswers,
  type TendenciaReading,
} from './tendencia.entity';

/**
 * O diagnóstico de um conjunto de respostas contra um gabarito — o do ensaio
 * (sub-aba Diagnóstico) ou o da prova oficial (aba Diagnóstico). A conta é a
 * leitura de padrão do ENAMED; isto só junta as entradas.
 *
 * `null` quando nenhuma questão tem dificuldade classificada: sem faixa onde
 * pôr o erro, não há leitura a fazer.
 */
export function diagnose(
  answerKey: AnswerKeyEntry[],
  answers: Answers,
): TendenciaReading | null {
  if (readableQuestions(answerKey).length === 0) return null;
  // As respostas são esparsas: `toSubmittedAnswers` completa as em branco
  // com `NAO_LEMBRO`, contra o gabarito.
  return readTendencia(
    answerKey,
    toSubmittedAnswers(answerKey, toAnswerIndexes(answers)),
  );
}
